import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  root:{
    borderRadius: '12px 12px 0px 0px',
    border: '2px solid #FFF',
    background: 'linear-gradient(113deg, rgba(255, 255, 255, 0.66) 0%, rgba(255, 255, 255, 0.64) 110.84%)',
  },
  headerIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: theme.palette.grey.grey200,
    width: '57px',
    height: '45px',
    borderRadius: '6px',
    marginRight: '11px'
  },
  header:{
    padding: '28px 29px 0px 29px',
  },
  titleContainer: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '17px'
  },
  title: {
    fontSize: '22px',
    fontWeight: 600,
    color: theme.palette.black.dark,
    textTransform: 'uppercase'
  },
  goToModelIcon: {
    marginLeft: '11px',
    marginRight:'13px',
    cursor: 'pointer'
  },
  infoWrapper: {
    display: 'flex',
    alignItems: 'center'
  },
  modelName: {
    padding: '4px 10px',
    background: theme.palette.grey.grey100,
    borderRadius: '16px',
    fontSize: '10px',
    fontWeight: 700,
    color: theme.palette.grey.grey600,
    marginLeft: '7px'
  },
  status: {
    fontSize: '14px',
    fontWeight: 600,
    color: theme.palette.grey.grey500
  },
  divider: {
    height: '1px',
    padding: '0px 29px',
    marginTop: '21px',
    width: '100%',
    background: theme.palette.grey.grey200,
  },
  label: {
    fontSize:'12px',
    color: theme.palette.grey.grey400,
    fontWeight: 600,
    marginBottom: '13px'
  },
  descriptionText: {
    color: theme.palette.grey.grey700,
    fontSize: '12px'
  },
  expirationDateWrapper: {
    marginLeft: 'auto'
  },

  expirationDate: {
    display: 'flex',
    alignItems:'center'
  },
  expirationDateText: {
    color: theme.palette.grey.grey700,
    fontSize: '14px',
    marginLeft: '8px'
  }
}));

export default useStyles;
